// PT-7443: Configuration for mood/USP images A/B test (Test 1)
export const MOOD_IMAGE_CONFIG: Record<
  string,
  { imageName: string; position: number }
> = {
  '/products/nassfutter-geniesser-filets-ente-und-spargel-fur-katzen': {
    imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Ente-02.jpg',
    position: 4,
  },
  '/products/nassfutter-juicy-filets-huhnerfilet-fur-katzen': {
    imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Huhn-02.jpg',
    position: 4,
  },
  '/products/nassfutter-juicy-filets-lachsfilet-fur-katzen': {
    imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Lachs-02.jpg',
    position: 4,
  },
  '/products/juicy-filets-huhn-mit-lammleber-und-karotte-fur-katzen': {
    imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Lamm-02.jpg',
    position: 4,
  },
  '/products/juicy-filets-thunfisch-fur-katzen': {
    imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-Thunfisch-02.jpg',
    position: 4,
  },
  '/products/juicy-filets-multipack-huhn-mit-ei-ente-huhn-mit-lammleber-fur-katzen':
    {
      imageName: 'pd-MKT-ABC-PDP-Test-Juicy-Filets-01.jpg',
      position: 2,
    },
  '/products/nassfutter-senior-huhn-mit-kartoffel-ricotta-birne-fur-hunde': {
    imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Senior-Huhn-02.jpg',
    position: 3,
  },
  '/products/nassfutter-senior-rind-mit-zucchini-kurbis-apfel-fur-hunde': {
    imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Senior-Rind-02.jpg',
    position: 3,
  },
  '/products/nassfutter-kanguru-mit-kurbis-quinoa-und-kamille-fur-hunde': {
    imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Kaenguru-02.jpg',
    position: 4,
  },
  '/products/nassfutter-pferd-mit-susskartoffel-und-distelol-fur-hunde': {
    imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Pferd-02.jpg',
    position: 4,
  },
  '/products/nassfutter-sensitiv-ziege-mit-pastinake-und-distelol-fur-hunde': {
    imageName: 'pd-MKT-ABC-PDP-Test-NaFu-Hypo-Ziege-02.jpg',
    position: 4,
  },
};

// PT-7443: Configuration for ABCD test (Test 2)
export const ABCD_TEST_CONFIG: Record<
  string,
  {
    moodImage: string;
    uspImage: string;
    moodPosition: number;
    uspPosition: number;
  }
> = {
  '/products/nassfutter-saucen-menu-huhnerfilet-mit-zucchini-fur-katzen': {
    moodImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Huhn-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Huhn-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
  '/products/nassfutter-saucen-menu-mit-lachsfilet-fur-katzen': {
    moodImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Lachs-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Lachs-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
  '/products/nassfutter-saucen-menu-rind-mit-kurbis-fur-katzen': {
    moodImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Rind-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Rind-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
  '/products/nassfutter-saucen-menu-thunfischfilet-fur-katzen': {
    moodImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Thunfisch-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-Saucen-Menue-Thunfisch-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
  '/products/trockenfutter-soft-huhn-mit-kurbis-preiselbeere-fur-hunde': {
    moodImage: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Huhn-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Huhn-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
  '/products/trockenfutter-soft-rind-mit-brokkoli-granatapfel-fur-hunde': {
    moodImage: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Rind-01.jpg',
    uspImage: 'pd-MKT-ABC-PDP-Test-TroFu-Soft-Rind-02.jpg',
    moodPosition: 4,
    uspPosition: 4,
  },
};
